import React from 'react';

const OnboardingAddresses = () => {
    return <div>OnboardingAddresses</div>;
};

export default OnboardingAddresses;
